<app-update-banner />
<router-outlet />